import { RouterManager } from '@aclass/admin/managers';
import { ConsentStory } from '@aclass/admin/storage/actions';
import { IAdminState, IConsentModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class ConsentEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:consent-edit';

    private id: IConsentModuleState['editPageRecordId'];

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IConsentModuleState['editPageRecordId']>(['consentModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(ConsentEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        const id = parseInt(route.params.id);
        this.id = id;
        this.ngRdx.dispatch(ConsentStory.dryRunEditPage(id));
    }
}
